import { DynamicIcon } from "@/components/categories/DynamicIcon";
import { cn } from "@/lib/utils";
import type { Category } from "@/types";

function withHash(hex: string): string {
  return hex.startsWith("#") ? hex : `#${hex}`;
}

interface CategoryChipProps {
  category?: Category;
  /** Show the colored icon dot before the label. */
  withIcon?: boolean;
}

/** Colored category pill (dot + name) tinted with the category color. */
export function CategoryChip({ category, withIcon = false }: CategoryChipProps) {
  if (!category) return <span className="text-pulso-muted">—</span>;
  const color = withHash(category.colorHex);
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 rounded-full py-0.5 text-xs font-semibold",
        // With a leading icon dot the left padding is tighter; without, keep it even.
        withIcon ? "pl-1.5 pr-2.5" : "px-2.5",
      )}
      style={{ background: `${color}1A`, color }}
    >
      {withIcon && (
        <span
          className="flex h-3.5 w-3.5 items-center justify-center rounded-[5px] text-white"
          style={{ background: color }}
        >
          <DynamicIcon name={category.iconName} className="h-2.5 w-2.5" strokeWidth={2.5} />
        </span>
      )}
      {category.name}
    </span>
  );
}
